export default __webpack_public_path__ + "static/media/Esmax-20-Tab-ban.b8cd6ff4.jpg";